import React from "react";
import styled from 'styled-components'
import ContentLoadingSpinner from "components/shared/spinners/ContentLoadingSpinner";
import PageLoadErrorMessage from "components/shared/alerts/PageLoadErrorMessage";

const PageLoadingInterstitialContainer = styled.div`
    height: calc(100vh - 64px);
`

export default ({ loading, error }) => (
	<PageLoadingInterstitialContainer>
		<PageLoadErrorMessage loading={loading} error={error} />
		<div className="p-32 w-full h-full flex justify-center">
			<ContentLoadingSpinner className="w-full h-full" />
		</div>
	</PageLoadingInterstitialContainer>
);